/**
 * @ComponentFor EPiServer.Core.ContentArea
 */
export { default } from '@avensia/scope-episerver/PropertyTypes/ContentArea';
